import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanySeeking as Seeking } from '@/types';
import '../user.css';
import { formatMoney, formatPrice, trimSixty } from '@/utils/format';
import { Image } from '@/components/Elements';
import { changeFav } from '@/api/propertyInvestment/changeFav';
import plus from '@/assets/plus.png';
import tag from '@/assets/tag.png';
import FileViewer from '@/components/Viewer/FileViewer';
import { Modal } from 'react-responsive-modal';
import { Button } from '@/components/Elements/Button';
import { changeAllFav } from '@/api/changeAllFav';
import { useNotificationStore } from '@/stores/notifications';
import { deletePropertyItem } from '@/api/deletePropertyItem';
import { useAuth } from '@/lib/auth';
import storage from '@/utils/storage';
import i18next from 'i18next';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { upperFirst } from 'lodash';
import { FeatureAdd } from './FeatureAddDialog';

const CompanySeeking = ({
  item,
  headData,
  editIcon,
  deleteIcon,
  heartIcon,
  heartFavIcon,
  setHeartClicked,
  setDeleteClicked,
  has_subscription,
}: {
  deleteIcon: boolean;
  item: Seeking;
  headData: boolean;
  editIcon: boolean;
  heartFavIcon: boolean;
  heartIcon: boolean;
  setHeartClicked: any;
  setDeleteClicked: any;
  has_subscription: boolean;
}) => {
  const navigate = useNavigate();
  const [photo, setPhoto] = useState<any>();
  const localSymbol = storage.getSymbol();
  const localAmount = storage.getAmount();

  const [pics, setPics] = useState<any>();
  const [favIcon, setFavIcon] = useState<boolean>(!!item.is_favourite);
  const [showFeatureAdd, setShowFeatureAdd] = useState(false);

  useEffect(() => {
    try {
      if (item?.image_data && item?.image_data.length > 0) {
        const parsed_data = item?.image_data;
        setPhoto(parsed_data[0]);
      }
    } catch (error) {
      console.error('Error evaluating image_data:', error);
    }
  }, [item?.image_data]);

  // useEffect(() => {
  //   if (item?.image_data) {
  //     const parsed_data = item?.image_data;
  //     setImg1(parsed_data[0]);
  //   }
  // }, [item?.image_data]);

  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const { user } = useAuth();

  const handleWithdraw = (e) => {
    e.stopPropagation();
    const payable = Math.floor((item?.investment_amount * 2.5) / 100);
    navigate(
      `/user/pay-commision/150?price=${payable}&type=doByReeipo&propType=${item?.type}&propId=${item?.id}`
    );
  };

  const onOpenModals = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setOpen(true);
  };

  const onShowModals = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setShow(true);
  };
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const onCloseModal = () => setOpen(false);
  const onHideModal = () => setShow(false);

  const typeVal = 'CompanySeeking';
  const deleleItems = async (id: string, types: string) => {
    try {
      setButtonLoading(true);
      await deletePropertyItem(id, types);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Item deleted successfully!',
      });
    } finally {
      setDeleteClicked(true);
      setOpen(false);
      setButtonLoading(false);
    }
  };

  const deleleItemsSelect = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    deleleItems(item.id, typeVal);
  };
  const changeStatusAction = async (id: string, accept: boolean) => {
    try {
      if (user) {
        await changeFav(id, accept);
        setHeartClicked(true);
      } else {
        useNotificationStore.getState().addNotification({
          title: 'Warning',
          type: 'info',
          message: 'Please Login first!',
        });
        navigate('/auth/login');
      }
    } finally {
    }
  };
  const handleClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setFavIcon((val) => !val);
    changeStatusAction(item.id, false);
  };
  const handleClick2 = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeStatusAction(item.id, true);
    setFavIcon((val) => !val);
  };
  const handleEdit = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    navigate(`/user/company-seeking-equity?id=${item.id}&type=CompanySeeking`);
  };
  const changeUnfavStatusAction = async (id: string, type: string) => {
    try {
      const data: any = await changeAllFav(id, type);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: upperFirst(data?.message),
      });
    } finally {
      setHeartClicked(true);
    }
  };
  const handleUnfavourite = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeUnfavStatusAction(item.id, item.type);
    // refetch();
  };
  const handleNavigate = () => {
    navigate(`/company-seeking-equity/${item.id}?type=CompanySeeking`);
  };
  const [value, setValue] = React.useState('thirty');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  return (
    <>
      <div className="col-12 col-md-6 col-lg-3 home-prop-col">
        <button className="housingButton" onClick={handleNavigate}>
          <div className="item-box deals-page p-2 position-relative">
            {headData == true ? (
              <>
                <div className="head-functions">
                  <span className="status">{i18next.t('Company Seeking')}</span>
                  <div className="d-flex icons">
                    {editIcon == true ? (
                      <span>
                        <button onClick={handleEdit}>
                          <i className="fa-solid fa-pen" />
                        </button>
                      </span>
                    ) : null}
                    {deleteIcon == true ? (
                      <span>
                        <button onClick={onOpenModals}>
                          <i className="fa-solid fa-trash" />
                        </button>
                      </span>
                    ) : null}
                    {heartIcon == true ? (
                      <div className=" fav-lists">
                        {favIcon ? (
                          <button onClick={handleClick}>
                            <i className="fa-solid fa-heart"></i>
                          </button>
                        ) : (
                          <button onClick={handleClick2}>
                            <i className="fa-regular fa-heart"></i>
                          </button>
                        )}
                      </div>
                    ) : null}
                    {heartFavIcon == true ? (
                      <div className=" fav-lists">
                        <button onClick={handleUnfavourite}>
                          <i className="fa-solid fa-heart"></i>
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="head-functions3">
                  <span
                    className={`status ${
                      item?.status == 'Approved'
                        ? 'approved'
                        : item?.status == 'Pending'
                        ? 'pending'
                        : 'disapprove'
                    }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item?.status}
                  </span>
                  {(has_subscription && item?.status === 'Approved') || item?.is_ad_featured ? (
                    <span className="feature" onClick={(e) => e.stopPropagation()}>
                      Featured
                    </span>
                  ) : (
                    !has_subscription &&
                    !item?.is_ad_featured &&
                    item?.status === 'Approved' && (
                      <span
                        className="status"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowFeatureAdd(true);
                        }}
                      >
                        Add Feature
                      </span>
                    )
                  )}
                  {/* {!has_subscription && item?.status == 'Approved' ? (
                    item?.is_ad_featured ? (
                      <span className="feature" onClick={(e) => e.stopPropagation()}>
                        Featured
                      </span>
                    ) : (
                      <span
                        className="status"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowFeatureAdd(true);
                        }}
                      >
                        Add Feature
                      </span>
                    )
                  ) : null
                  } */}
                </div>
              </>
            ) : (
              <div className="head-functions2 ">
                {item.is_favourite == true ? (
                  <button onClick={handleClick}>
                    <i className="fa-solid fa-heart"></i>
                  </button>
                ) : (
                  <button onClick={handleClick2}>
                    <i className="fa-regular fa-heart"></i>
                  </button>
                )}
              </div>
            )}
            {/* {item?.image_data.length == 0 ? (
              <FileViewer file={plus ?? ''}></FileViewer>
            ) : (
              <Image
                // imagefallback={eval(item?.image_data)[0]?.image}
                className="itemImage"
                alt="banner"
                src={photo ?? ''}
              />

            )} */}

            {item?.image_data ? (
              <>
                {item?.image_data.length == 0 ? (
                  <FileViewer file={plus ?? ''}></FileViewer>
                ) : (
                  <div className="res-slider-icon">
                    <Image
                      // imagefallback={eval(item?.image_data)[0]?.image}
                      className="itemImage"
                      alt="banner"
                      src={photo ?? ''}
                    />
                  </div>
                )}
              </>
            ) : null}

            {/* {!has_subscription && item?.status == 'Approved' ? (
              item?.is_ad_featured ? (
                <Button
                  variant="inverse"
                  size="sm"
                  className="add-faetre-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  Feature Added
                </Button>
              ) : (
                <Button
                  size="sm"
                  className="add-faetre-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFeatureAdd(true);
                  }}
                >
                  Add Feature
                </Button>
              )
            ) : null} */}

            <h6 className="mt-3 text-dark">{item?.offered_by}</h6>
            <p className="text-sm stx text-dark">
              <i className="fa-solid fa-map-location-dot"></i>
              {item.location}
            </p>
            {/* <p className="text-sm asd">
              fg
              {i18next.t('Development')} | {i18next.t('Equity')}
            </p> */}
            {/* <div className="greyTxt row">
              <p className="col-md-6 col-6 leftw">
                {i18next.t('Target return on cost')} <br />
                {/* {formatMoney(item?.target_return_on_cost)} */}
            {/* {localSymbol} {formatPrice(item.target_return_on_cost * localAmount)}
              </p> */}
            {/* <p className="col-md-6 col-6 leftww">
                {i18next.t('Target IRR')}
                <br /> */}
            {/* {formatMoney(item?.target_irr)} */}
            {/* {localSymbol} {formatPrice(item.target_irr * localAmount)}
              </p> 
            </div> */}

            <div className="tab">
              <p>{i18next.t('Share For Sale')}</p>
              <p>
                {/* {localSymbol} {formatPrice(Number(item.share_for_sale) * localAmount)} */}
                {localSymbol} {formatPrice(Number(item.share_for_sale) * localAmount)}
              </p>
            </div>

            <div className="tab">
              <p>{i18next.t('Maximun Drawing')}</p>
              <p>
                {localSymbol} {formatPrice(Number(item.maximum_drawing) * localAmount)}
              </p>
            </div>

            <div className="tab">
              <p>{i18next.t('Minimum Drawing')}</p>
              <p>
                {localSymbol} {formatPrice(Number(item.minimum_drawing) * localAmount)}
              </p>
            </div>
            <div className="tab">
              <p>{i18next.t('Invested Amount')}</p>
              <p>
                {localSymbol} {formatPrice(Number(item?.investment_amount) * localAmount)}
              </p>
            </div>
            {item?.investment_amount > 0 && item?.payment_status === false ? <div className="flex justify-center items-center w-full my-2">
                <Button onClick={(e) => handleWithdraw(e)}>Stop</Button>
              </div> : null}
          </div>
        </button>
        <Modal open={show} onClose={onCloseModal} center>
          <section className="model-datas text-center">
            <h3> {i18next.t('Are you sure you want to delete this item ?')}</h3>
          </section>
          <p className="btn-lines delete-bots d-flex justify-content-center">
            <Button isLoading={buttonLoading} onClick={deleleItemsSelect}>
              {i18next.t('Yes')}
            </Button>
            <Button onClick={onCloseModal}>{i18next.t('No')}</Button>
          </p>
        </Modal>
        {/* Add Feature mOdal */}
        <Modal className="select-plan-model" open={open} onClose={onHideModal} center>
          <section className="model-datas feature-modal text-center">
            <img src={tag} className="m-auto tag-icon" />
            <h3 className="text-center text-dark f-20 mt-3 font-semibold">Select plan</h3>
            <p className="text-dark text-center f-14 mb-4">Simple and flexible per-user pricing.</p>
            <div className="applicable-tct">Applicable for Mobile Features</div>
            <div className="feature-ad d-flex justify-between items-center">
              <h4 className="font-semibold text-dark f-20">Feature Ad</h4>
              <Button variant="outline" className="f-13" size="sm">
                See More
              </Button>
            </div>
            <p className="f-13 d-flex gap-2 items-center  text-dark">
              <i className="fa-solid fa-circle-check pink f-14"></i> Get Noticed with 'FEATURED' tag
              in a top position{' '}
            </p>
            <p className="f-13 d-flex items-center  gap-2 text-dark">
              <i className="fa-solid fa-circle-check pink f-14"></i> Ad will be highlighted to top
              positions{' '}
            </p>
            <div className="feature-box">
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChange}
              >
                <div className="features-max">
                  <div className="d-flex justify-between items-center">
                    <FormControlLabel
                      value="thirty"
                      control={<Radio />}
                      label="New Featured Ad for 30 days"
                    />
                    <p className="text-dark font-semibold f-14">$239</p>
                  </div>
                  <p className="f-13 d-flex items-center  gap-2">
                    <i className="fa-solid fa-check"></i>Reach upto 10 times more buyers
                  </p>
                </div>
                <div className="features-max">
                  <div className="d-flex justify-between items-center">
                    <FormControlLabel
                      value="seven"
                      control={<Radio />}
                      label="New Featured Ad for  7 days"
                    />
                    <p className="text-dark font-semibold f-14">$139</p>
                  </div>
                  <p className="f-13 d-flex items-center gap-2">
                    <i className="fa-solid fa-check"></i>Reach upto 4 times more buyers
                  </p>
                </div>
              </RadioGroup>
            </div>
          </section>
          <p className="btn-lines delete-bots gap-1 d-flex justify-content-center">
            <Button variant="outline" className="rounded-full" onClick={onHideModal}>
              Cancel
            </Button>
            <Button className="rounded-full pink-btn">Confirm</Button>
          </p>
        </Modal>
      </div>

      <FeatureAdd
        propType="company_seeking_equity"
        propId={item.id}
        show={showFeatureAdd}
        setShow={setShowFeatureAdd}
      />
    </>
  );
};

export default CompanySeeking;
